import React,{ Component } from "react";
import {Empty, Skeleton, Tabs,message} from 'antd';
import Axios from '../.././../../components/request/axios'
import Moment from 'moment'
import './index.less'
import IsLogin from "../../../../components/is_require_login";
const { TabPane } = Tabs;
class News extends Component {
    state={
        activeKey:'0',
        news:[], ///文章内容数组
        loading:true,
        channel__id:''
    };
    componentDidMount() {
        let _this=this;
        let channel__name=this.props.list[0].props.children[1].replace(/(^\s*)|(\s*$)/g, "");///默认获取第一个tab的名称
        let params={
            channel__name:channel__name
        };
        Axios.get('/api/v1/news/',params).then((res)=>{
            if(res){
                if(res.results.length <= this.props.length){//最多加载9个
                    _this.setState({
                        news:res.results,
                        loading:false,
                        channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:''
                    })
                }else {
                    let news=res.results.slice(0,this.props.length);
                    _this.setState({
                        news:news,
                        loading:false,
                        channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:''
                    })
                }
            }
        });
    }
    ActiveKey=(activeKey)=>{ ///设置活动页的key值
        let OldActiveKey=this.state.activeKey;////之前的activekey
        if(OldActiveKey!==activeKey){//activekey不相等才会再次请求接口
            this.setState({
                loading:true
            });
            let channel__name=this.props.list[Number(activeKey)].props.children[1].replace(/(^\s*)|(\s*$)/g, "");///默认获取第一个tab的名称
            let params={
                channel__name:channel__name ///默认为学术动态的id
            };
            let _this=this;
            Axios.get('/api/v1/news/',params).then((res)=>{
                if(res){
                    if(res.results.length <= this.props.length){
                        _this.setState({
                            news:res.results,
                            loading:false,
                            activeKey, //重置activeKey的值
                            channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:''
                        })
                    }else {
                        let news=res.results.slice(0,this.props.length);
                        _this.setState({
                            news:news,
                            loading:false,
                            activeKey, //重置activeKey的值
                            channel__id:res.results[0]?res.results[0].channel.split('/')[res.results[0].channel.split('/').length-2]:''
                        })
                    }
                }
            });
        }

    };
    toMore=()=>{// 查看更多内容，跳转到更多的页面
        let channel=this.state.channel__id;///获取channel id
        if(channel){//存在channel id ，可以跳转查看更多
            window.location.hash='#/news?key='+channel;
        }else {
            let activeKey=Number(this.state.activeKey);
            let channel__name=this.props.list[activeKey].props.children[1].replace(/(^\s*)|(\s*$)/g, "");///默认获取第一个tab的名称
            message.warning(channel__name+'没有更多内容！')
        }
    };
    toShowNews=(hash,require_login)=>{
        let is_logoin=IsLogin(require_login);
        if(is_logoin){//已经登录,或者不需要用户登录就能查看
            window.location.hash=hash;
        }else {
            message.warning('登录后才能查看详情');
        }
    };
    render() {
        let {news,loading,channel__id}=this.state;
        let {list}=this.props;
        return <div style={{width:"100%"}} className='news'>
            <div className='more' onClick={()=>this.toMore()}> 更多></div>
           <Tabs defaultActiveKey="0" onChange={this.ActiveKey.bind(this)} >
               {list.map((item,index)=>{
                   return <TabPane tab={item} key={index}>
                       <Skeleton  active  loading={loading}>
                           {news.length>0?
                               <ul style={{marginBottom:'0'}}>
                                   {news.map((item2,index2)=>{
                                       let hash='#/news/newshow?id='+item2.id+"&key="+channel__id;
                                       return  <li key={index2}>
                                           <span  onClick={()=>this.toShowNews(hash,item2.require_login)} >
                                               <span>{item2.title}</span>
                                               <span>{Moment(item2.create_time).format('YYYY-MM-DD')}</span>
                                           </span>
                                       </li>
                                   })}
                               </ul>:<Empty description='暂无数据' />
                           }
                       </Skeleton>
                   </TabPane>
               })}
           </Tabs>
         </div>
    }
}
export default News